import { Box } from "@mui/material";
import { getUserCached } from "actions/cached";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const UserBy = ({ id }) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!id) return;

    const fetchUser = async () => {
      const res = await dispatch(getUserCached(id));
      setUser(res);
    };

    fetchUser();
  }, [id, dispatch]);

  if (!id) return null;

  return <Box>{user ? `${user.first_name} ${user.last_name}` : id}</Box>;
};

export default UserBy;
